import { useQuery } from '@tanstack/react-query';
import { fetchProcessesForCycle } from '../../request/sox';
import { fetchFlowchartVersions } from '../../request/flowchart';
import { flowchartVersionsQueryKey } from '../../queries/flowchart';
import { processesQueryKey } from '../../queries/sox';

export function useFlowchartQueries({ cycleId, processId, auditYearId }) {
  const { data: allProcesses = [] } = useQuery({
    queryKey: [...processesQueryKey(cycleId), auditYearId ?? ''],
    queryFn: () => fetchProcessesForCycle(cycleId, auditYearId),
    enabled: Boolean(cycleId)
  });

  const {
    data: versionOptions = [],
    refetch: refetchVersionOptions
  } = useQuery({
    queryKey: flowchartVersionsQueryKey(cycleId, processId, auditYearId),
    queryFn: () => fetchFlowchartVersions(cycleId, processId, auditYearId),
    enabled: Boolean(cycleId && processId)
  });

  return {
    allProcesses,
    versionOptions,
    refetchVersionOptions
  };
}
